import React from 'react';
import { THEME } from '../constants';
import PropTypes from 'prop-types';

const PickTypePerformance = ({ data }) => {
    if (!data) return null;

    const renderPerformanceRow = (pickType) => {
        const winPercentage = pickType.win_percentage;

        return (
            <div className="performance-row" key={pickType.pick_category}>
                <div className="performance-header">
                    <h4>{pickType.pick_category}</h4>
                    <span className="total-picks">({pickType.total_picks} picks)</span>
                </div>
                <div className="performance-bar-container">
                    <div className="performance-bar">
                        <div
                            className="win-bar"
                            style={{
                                width: `${winPercentage}%`,
                                backgroundColor: THEME.colors.win
                            }}
                        />
                        <div
                            className="loss-bar"
                            style={{
                                width: `${100 - winPercentage}%`,
                                backgroundColor: THEME.colors.loss
                            }}
                        />
                    </div>
                    <div className="performance-stats">
                        <span className="win-percentage">{winPercentage}%</span>
                        <span className="record">({pickType.wins}-{pickType.losses})</span>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="chart-container pick-type-performance">
            <h3>Pick Type Performance</h3>
            <div className="performance-grid">
                {data.map(pickType => renderPerformanceRow(pickType))}
            </div>
        </div>
    );
};

PickTypePerformance.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        pick_category: PropTypes.string.isRequired,
        total_picks: PropTypes.number.isRequired,
        wins: PropTypes.number.isRequired,
        losses: PropTypes.number.isRequired,
        win_percentage: PropTypes.number.isRequired
    })).isRequired
};

export default PickTypePerformance;
